import { localAddresses } from '../../generated/localAddresses';
import { iconSrcs } from '../../generated/manifests/tokenIcons';
import { ChainId, type Token } from '../../types';
import { tao } from '../nativeTokens';

const wtao: Token = {
  chainId: ChainId.LOCAL,
  address: localAddresses.wtao,
  decimals: 18,
  symbol: 'WTAO',
  iconSrc: iconSrcs.wtao,
  tokenWrapped: tao[ChainId.LOCAL],
};

const alpha30: Token = {
  chainId: ChainId.LOCAL,
  address: localAddresses.mockAlpha30,
  decimals: 18,
  symbol: 'ALPHA30',
  displaySymbol: 'alpha-30',
  iconSrc: iconSrcs.alpha,
};

const alpha64: Token = {
  chainId: ChainId.LOCAL,
  address: localAddresses.mockAlpha64,
  decimals: 18,
  symbol: 'ALPHA64',
  displaySymbol: 'alpha-64',
  iconSrc: iconSrcs.alpha,
};

export const local: Token[] = [tao[ChainId.LOCAL], wtao, alpha30, alpha64];
